export default __webpack_public_path__ + "static/media/IMG-20210326-WA0033.8a1f7516.jpg";